import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FbtBundleConfigContext } from '@udemy-v2/react-bundle-unit';

/**
 * Feeds the redesigned "Frequently Bought Together" bundle config into the shared cart success modal
 * (CartSuccessModal builds FrequentlyBoughtTogether internally, so config flows through context
 * rather than props). Must be an ancestor of every add-to-cart entry point on CLP.
 */
export const FbtBundleConfigProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      excludeAddedCourseFromBundle: true,
      showPerCardAddToCart: true,
      wideSuccessModal: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <FbtBundleConfigContext.Provider value={t1}>{children}</FbtBundleConfigContext.Provider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};